<template>
  <q-card class="vehicle-card" @mousedown="clickStart" @mouseup="clickEnd">
    <div class="relative-position">
      <div
        class="vehicle-card__badges flex items-center justify-start q-gutter-xs"
      >
        <HighlightBadge
          v-for="(tagData, i) in vehicle.tags.filter(
            tag => tag.tag !== 'Price Drop'
          )"
          :key="i + '_vehicleTagDataBadge'"
          :label="tagData.tag"
          :color="
            {
              'Price Drop': 'positive',
              'New Listing': 'blue'
            }[tagData.tag]
          "
          class="text-weight-medium"
          style="box-shadow: 0 1px 4px rgba(1, 1, 1, 0.3), 0 2px 4px rgba(1, 1, 1, 0.2), 0 3px 3px -4px rgba(1, 1, 1, 0.18); border-radius: 14px; font-size: 11px"
        />
      </div>

      <div class="vehicle-card__save">
        <VehicleWatchlistButton
          :product-id="vehicle.product_id"
          style="background: #13141594;"
          dense
        />
      </div>

      <ImageCarousel
        :images="vehicle.images"
        :ratio="4 / 3"
        class="vehicle-card__images"
        chevron-size="40px"
      />
      <ScoreBadge
        :score="vehicle.deal_score"
        class="--shadow__bottom vehicle-card__score"
      />
      <!--<ScoreCircle
        v-if="vehicle.match_score > 0"
        :rating="vehicle.match_score"
        class="vehicle-card__score"
      >
        <q-tooltip
          anchor="center right"
          self="center left"
          max-width="300px"
          :offset="[6, 6]"
          persistent
        >
          Your Match Score
        </q-tooltip>
      </ScoreCircle>-->
    </div>

    <div class="q-px-md q-pb-sm q-pt-xs">
      <div class="flex justify-between items-start no-wrap">
        <div class="ellipsis q-mr-sm">
          <p
            v-html="
              vehicle.year + ' ' + vehicle.make_raw + ' ' + vehicle.model_raw
            "
            class="text-weight-bold ellipsis"
            style="font-size: 1.26rem"
          />
          <p
            v-html="vehicle.trim.length > 0 ? vehicle.trim : '--'"
            class="ellipsis --text-sm text-text-light"
            style="margin-top: -3px"
          />
        </div>
        <!--<div class="flex items-center justify-start">
          <q-btn-dropdown
            round
            dense
            color="background-light"
            class="--shadow__bottom --bordered"
            @click.stop.prevent="() => {}"
            @mousedown.stop="() => {}"
            @mouseup.stop="() => {}"
            dropdown-icon="none"
          >
            <template v-slot:label>
              <q-icon name="sym_r_more_horiz" size="24px" />
              <q-tooltip
                anchor="center left"
                self="center right"
                max-width="300px"
                :offset="[6, 6]"
                persistent
              >
                Vehicle Insights
              </q-tooltip>
            </template>
            <q-list>
              <q-item
                clickable
                v-close-popup
                @click.stop.prevent="() => {}"
                @mousedown.stop="() => {}"
                @mouseup.stop="() => {}"
              >
                <q-item-section>
                  <q-item-label>Vehicle Insights</q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
                @click.stop.prevent="() => {}"
                @mousedown.stop="() => {}"
                @mouseup.stop="() => {}"
              >
                <q-item-section>
                  <q-item-label>Deal Score</q-item-label>
                </q-item-section>
              </q-item>

              <q-item
                clickable
                v-close-popup
                @click.stop.prevent="() => {}"
                @mousedown.stop="() => {}"
                @mouseup.stop="() => {}"
              >
                <q-item-section>
                  <q-item-label>Price History</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>-->
      </div>
      <div class="flex justify-between items-end no-wrap q-pb-xs full-width">
        <div class="flex items-center no-wrap q-mr-md q-mb-none">
          <h4 class="text-weight-bold q-mb-none" style="font-size: 1.87rem">
            {{ vehicle.price_formatted }}
          </h4>
          <PriceDropLabel
            v-if="
              vehicle.tags.filter(tag => tag.tag === 'Price Drop').length > 0
            "
            :amount-change="
              vehicle.tags.filter(tag => tag.tag === 'Price Drop')[0].metadata
                .amount_change
            "
            style="margin-left: 6px; margin-top: -2px"
          />
        </div>

        <div class="ellipsis text-right">
          <div class="flex items-center justify-end text-weight-bold no-wrap">
            <!--<q-icon name="sym_r_speed" size="18px" class="q-mr-xs" />-->
            <span v-html="formatNumber(vehicle.mileage, true) + ' mi'" />
            <!--<icon-double-arrow-down v-if="vehicle.tags.filter(tag => tag.tag === 'Low Mileage').length > 0" size="22" color="#047857" style="margin-right: -3px; margin-top: -2px"/>
            <icon-double-arrow-up v-if="vehicle.tags.filter(tag => tag.tag === 'High Mileage').length > 0" size="22" color="#B91C1B" style="margin-right: -3px; "/>-->
          </div>
          <div
            class="flex items-center justify-end ellipsis --text-sm text-text-light"
            style="margin-top: -3px"
          >
            <!--<icon-map-marker size="11" style="margin-right: 2px; min-width: 11px" />-->
            <span
              v-html="
                'distance' in vehicle
                  ? vehicle.distance + ' mi away'
                  : vehicle.dealer.city + ', ' + vehicle.dealer.state
              "
              class="ellipsis"
            />
          </div>
        </div>
      </div>
      <!--<div class="full-width q-my-sm">
        <q-btn
          label="Check Availability"
          color="secondary"
          class="full-width"
          rounded
          no-caps
        />
      </div>-->
    </div>
  </q-card>
</template>

<script>
import ImageCarousel from "@/components/UI/ImageCarousel.vue";
import VehicleWatchlistButton from "@/components/VehicleWatchlistButton.vue";
import vehicleHelpers from "@/mixins/vehicleHelpers";
import PriceDropLabel from "@/components/UI/PriceDropLabel.vue";
import ScoreBadge from "@/components/UI/ScoreBadge.vue";
import { Dialog } from "quasar";
import ListingDialog from "@/components/ListingDialog.vue";
import HighlightBadge from "@/components/UI/HighlightBadge.vue";

export default {
  name: "VehicleCard",
  mixins: [vehicleHelpers],
  components: {
    HighlightBadge,
    ScoreBadge,
    VehicleWatchlistButton,
    PriceDropLabel,
    ImageCarousel
  },
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      clickLocation: {
        x: 0,
        y: 0
      }
    };
  },
  mounted() {
    this.attachContentViewListeners(this.$el, {
      advertiser_account_id: this.vehicle.advertiser_account_id,
      event_value: this.vehicle.bid_value,
      product_id: this.vehicle.product_id
    });
  },
  methods: {
    clickStart(event) {
      this.clickLocation = {
        x: event.clientX,
        y: event.clientY
      };
    },
    clickEnd(event) {
      let clickDragThreshold = 10;
      let deltaX = Math.abs(event.clientX - this.clickLocation.x);
      let deltaY = Math.abs(event.clientY - this.clickLocation.y);
      let wasClickOperation =
        deltaX < clickDragThreshold && deltaY < clickDragThreshold;
      if (wasClickOperation) {
        this.handleClickedVehicle(this.vehicle);
      }
    },
    promptVehicleListingDialog(product_id) {
      Dialog.create({
        component: ListingDialog,
        componentProps: {
          productId: product_id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.vehicle-card {
  backface-visibility: hidden;
  will-change: all;
  transition: all 0.2s ease;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: color(background, light);

  &:hover {
    cursor: pointer;
  }

  @media (min-width: #{$screen-sm}) {
    &:hover {
      cursor: pointer;
      transform: scale(1.05) translateZ(1000px);
      box-shadow: 0 1px 12px rgba(1, 1, 1, 0.3), 0 3px 6px rgba(1, 1, 1, 0.2),
      0 3px 3px -4px rgba(1, 1, 1, 0.18);
      filter: brightness(1.08);
      background: color(background, very-light);
      border: 2px solid rgba(231, 23, 27, 0.74) !important;
    }
  }

  .vehicle-card__badges {
    position: absolute;
    top: $space-sm;
    left: $space-md;
    z-index: 10;
  }

  .vehicle-card__save {
    position: absolute;
    top: $space-sm;
    right: $space-md;
    z-index: 10;
  }

  .vehicle-card__images {
    box-shadow: $shadow-bottom;
    margin: $space-sm;
    border-radius: $border-radius;
    background: color(background);
  }

  .vehicle-card__score {
    position: absolute;
    bottom: $space-sm;
    left: $space-md;
  }
}
</style>
